import * as React from "react"
import { Link } from "gatsby"
import ConfigContext from '../context/ConfigProvider';

import "../styles/sub-navigation.scss"

export function SubNavigation({ productMod, location }) {
  const [activeMain, setActiveMain] = React.useState(false)
  const { configData } = React.useContext(ConfigContext);

  // Open the active menu
  React.useEffect(() => {
    if (configData && configData.categoryNav) {
      configData.categoryNav.forEach((obj) => {
        if (location && (obj.custom_url.url === location.pathname)) {
          setActiveMain(obj.bigcommerce_id);
        }
        if (!activeMain && productMod && productMod.product.categories.includes(obj.bigcommerce_id)) {
          setActiveMain(obj.bigcommerce_id);
        }
      });
    }
  }, [configData, location, productMod, activeMain]);

  const toggleActiveMain = (value) => setActiveMain(value);

  return (
    <div className="navigationBox">
      <nav id="subNavigation">
        <Categories 
          CategoryArray={configData?.categoryNav || []} 
          ProductCategories={productMod?.product?.categories || []} 
          activeMain={activeMain} 
          toggleActiveMain={toggleActiveMain} 
          location={location} 
        />
      </nav>
    </div>
  );
}

const Categories = ({ CategoryArray, ProductCategories, activeMain, toggleActiveMain, location }) => {
  React.useEffect(() => {
    CategoryArray.forEach((obj) => {
      const { custom_url, childrens, bigcommerce_id } = obj;
      if (custom_url.url === location?.pathname) {
        toggleActiveMain(bigcommerce_id);
      }
      if (childrens.length > 0) {
        childrens.forEach((childObj) => {
          const childCustomUrl = childObj.custom_url?.url?.replace(/\//g, "");
          const locPath = location?.pathname?.replace(/\//g, "");
          if (childCustomUrl === locPath || ProductCategories.includes(childObj.bigcommerce_id)) {
            toggleActiveMain(bigcommerce_id);
          }
        });
      }
    });
  }, [CategoryArray, ProductCategories, location, toggleActiveMain]);

  const topLevelArray = CategoryArray.map((obj, i) => {
    const subLevelArray = obj.childrens.map((childObj, j) => {
      const isActiveLink = childObj.custom_url?.url?.replace(/\//g, "") === location?.pathname?.replace(/\//g, "") || 
                          ProductCategories.includes(childObj.bigcommerce_id);
      return (
        <li key={childObj.id + "_" + j} className={isActiveLink ? "subCategory active" : "subCategory"}>
          <Link to={`${childObj.custom_url.url}`} title={"Gå till Tryck på " + childObj.name}>
            {isActiveLink ? "· " : ""}{childObj.name}
          </Link>
        </li>
      );
    });

    return (
      <div key={"category" + obj.id + "_" + i} className="subNavigationWrapper">
        <ul key={obj.id} className={activeMain === obj.bigcommerce_id ? "active" : ""}>
          <li className="mainCategory" onClick={() => toggleActiveMain(obj.bigcommerce_id === activeMain ? false : obj.bigcommerce_id)}>
            <Link to={`${obj.custom_url.url}`}>{obj.name}</Link>
          </li>
          {subLevelArray}
        </ul>
      </div>
    );
  });

  return <>{topLevelArray}</>;
};